import { Filesystem, Directory } from '@capacitor/filesystem';
import CryptoJS from 'crypto-js';

export class FileSystem {
    static persistentPath = Directory.Data;
    static temporaryPath = Directory.Cache;

    _checkEntry = function (source) {
        if (typeof source === 'string') {
            return this.find(source);
        } else {
            return Promise.resolve(source);
        }
    };

    makeFilename (name, ext = null, temporary = false) {
        const TYPE = temporary ? FileSystem.persistentPath : FileSystem.temporaryPath;
        let file = `${TYPE}://${name}${ext ? ('.' + ext) : ''}`;
        return file;
    }

    /**
     * Upload file
     * @param {*} param0
     */
    async upload ({ url, method = 'POST', fileKey, fileName, params = {}, path, onProgress }) {
        const archivo = await this.find(path);

        const formData = new FormData();
        formData.append('audio', base64ToBlob(archivo.data), 'audio.aac');

        for (const key in params) {
            formData.append(key, params[key]);
        }

        const response = await fetch(url, {
            method: method,
            body: formData
        });

        return response.json();
    }

    parseFile (uri) {
        const [directory, path] = uri.split('://');
        return {
            directory,
            path
        };
    }

    /**
     * Donwload file to destination
     * @param {string} param0
     */

    async download ({ url, dst }) {
        return new Promise(async (resolve, reject) => {
            const response = await fetch(url);
            const blob = await response.blob();
            const reader = new FileReader();

            reader.onloadend = async () => {
                const base64Data = reader.result;

                const writeResponse = await Filesystem.writeFile({
                    // path: dst,
                    ...this.parseFile(dst),
                    data: base64Data.split(',')[1] // Remover el encabezado del base64
                    // directory: Directory.Data
                });
                console.log(writeResponse);

                return resolve(writeResponse);
            };
            reader.readAsDataURL(blob); // Leer el blob como Data URL
        });

        // let uri = window.encodeURI(url);
        // let fileTransfer = new window.FileTransfer();

        // return new Promise((resolve, reject) => {
        //     fileTransfer.download(uri, dst, resolve, reject, false, {});
        // });
    }

    /**
     * Find entryfile. Busca un archivo en disco.
     * @param {string} path
     */
    find (uri) {
        const { path, directory } = this.parseFile(uri);
        return Filesystem.readFile({
            path, directory
        });
    }

    delete (uri) {
        const { path, directory } = this.parseFile(uri);
        return Filesystem.deleteFile({
            path, directory
        });
    }

    /**
     *
     * @param {string|FileEntry} source
     * @param {string} destFolder
     * @param {string} name Filename destination
     */
    copy (source, destFolder) {
        const sourceData = this.parseFile(source);
        const destData = this.parseFile(destFolder);

        return Filesystem.copy({
            from: sourceData.path,
            to: destData.path,
            directory: sourceData.directory,
            toDirectory: destData.directory
        });
    }

    writeFile (fileName, data) {
        const sourceData = this.parseFile(fileName);
        return Filesystem.writeFile({
            path: sourceData.path,
            data: data,
            directory: sourceData.directory
        });
    }

    async readFile (fileName) {
        const sourceData = this.parseFile(fileName);
        const result = await Filesystem.readFile({
            path: sourceData.path,
            directory: sourceData.directory
        });
        return result.data;
    }

    /**
     * Check MD5 File
     * @param {string|FileEntry} source
     * @param {string} md5
     */

    check (source, md5) {
        return this.find(source).then(file => {
            const palabra = CryptoJS.enc.Base64.parse(file.data);
            const hash = CryptoJS.MD5(palabra).toString();
            if (hash === md5) {
                return md5;
            } else {
                throw new Error('corrupted');
            }
        });
    }

    /**
     *
     * @param {string} filename
     */
    filenameExtension (filename) {
        const index = filename.lastIndexOf('.');
        if (index >= 0) {
            return filename.substring(index + 1);
        }
        return '';
    }

}

function base64ToBlob (base64, mimeType = '') {
    // Decodificar el string Base64
    const byteCharacters = atob(base64);

    // Crear un array de bytes
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    // Crear un Blob con el array de bytes y el tipo MIME
    return new Blob([byteArray], { type: mimeType });
}



// WEBPACK FOOTER //
// ./src/cordova/FileSystem.js